/**
 * Track — fire-and-forget event tracker dla Public pages.
 *
 * Wysyła event do POST /api/public/events. Bezpieczny dla SSR (sprawdza window).
 * Dedup: visit eventy są wysyłane raz na 1h per (entity_id + sessionStorage).
 */
import { API_BASE } from './api';

const DEDUP_TTL_MS = 60 * 60 * 1000; // 1 godzina

function shouldDedup(eventType, key) {
  if (typeof window === 'undefined' || !key) return false;
  // Tylko dla view_* eventów dedup-ujemy
  if (!eventType.startsWith('view_')) return false;
  try {
    const stored = sessionStorage.getItem(`apisai_track_${key}`);
    if (!stored) return false;
    const ts = parseInt(stored, 10);
    return Number.isFinite(ts) && Date.now() - ts < DEDUP_TTL_MS;
  } catch {
    return false;
  }
}

function markDedup(eventType, key) {
  if (typeof window === 'undefined' || !key) return;
  if (!eventType.startsWith('view_')) return;
  try {
    sessionStorage.setItem(`apisai_track_${key}`, String(Date.now()));
  } catch {}
}

/**
 * Wyślij event trackingowy.
 * @param {string} type — np. 'view_business', 'tel_click', 'email_click'
 * @param {object} payload — { entity_type, entity_id, slug, user_id, name, service_id, ... }
 */
export function track(type, payload = {}) {
  if (typeof window === 'undefined') return;
  const dedupKey = `${type}_${payload.entity_id || payload.slug || ''}`;
  if (shouldDedup(type, dedupKey)) return;
  markDedup(type, dedupKey);

  const body = JSON.stringify({ type, payload });
  // Preferowany navigator.sendBeacon (działa też przy nawigacji)
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      const ok = navigator.sendBeacon(`${API_BASE}/api/public/events`, blob);
      if (ok) return;
    }
  } catch {}
  // Fallback fetch (fire-and-forget)
  try {
    fetch(`${API_BASE}/api/public/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {}
}

export default track;
